module.exports = __webpack_public_path__ + "static/media/backgroundImage1.9fb0d5b7.svg";